import { useLayoutEffect } from 'react'

export default function useLockBodyScroll(defaultOverflow) {
  useLayoutEffect(() => {
    // Get original value of body overflow
    const originalOverflowStyle = window.getComputedStyle(document.body).overflow
    const originalPositionStyle = window.getComputedStyle(document.body).position
    const originalWidth = window.getComputedStyle(document.body).width
    // Prevent scrolling on mount
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed' // For ios devices
    document.body.style.width = '100%'
    // Re-enable scrolling when component unmounts
    return () => {
      document.body.style.overflow = defaultOverflow ?? originalOverflowStyle
      document.body.style.position = originalPositionStyle
      document.body.style.width = originalWidth
    }
  }, [defaultOverflow])
}
